import { useEffect, useState, useMemo } from 'react';
import { AvailableMessages, usePostMessageToMobileApp } from '@kiwicom/web-message-schemas';
import { useLog } from '@kiwicom/nitro/lib/services/log/context';
import { Category, createEventLogUnified, UIEvent, ErrorAction } from '@/common/services/logging';
import { isWebview } from '@kiwicom/nitro/lib/services/platform/client';

const useIsNativeMessageSupported = (message: string) => {
  const { postMessage } = usePostMessageToMobileApp();
  const [availableMessages, setAvailableMessages] = useState<string[]>([]);
  const { log } = useLog();

  // Capture webview status once at mount, like the original useSSRFlags approach
  const isInApp = useMemo(() => isWebview(), []);

  useEffect(() => {
    if (isInApp) {
      const availabilityMessage: AvailableMessages = {
        message: 'availableMessages',
        response: [],
      };
      void postMessage(availabilityMessage)
        .then((messages: string[]) => {
          const availableMessages = messages;
          setAvailableMessages(availableMessages);
          void log(createEventLogUnified(Category.COMMON, UIEvent.Loaded, 'native messages'), {
            availableMessages: messages.toString(),
          });
        })
        .catch(() => {
          void log(
            createEventLogUnified(
              Category.COMMON,
              ErrorAction.ErrorOccurred,
              'failed to load native messages',
            ),
            {},
          );
        });
    }
  }, [isInApp, log, postMessage]);

  return availableMessages.includes(message);
};

export default useIsNativeMessageSupported;
